import React, { useState } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import { BellIcon as BellSolidIcon } from '@heroicons/react/24/solid';
import { useNotifications } from '../../hooks/useNotifications';
import NotificationsPanel from './NotificationsPanel';

interface NotificationsBellProps {
  className?: string;
  onOpenCenter?: () => void;
}

const NotificationsBell: React.FC<NotificationsBellProps> = ({
  className = '',
  onOpenCenter,
}) => {
  const { unreadCount } = useNotifications();
  const [showPanel, setShowPanel] = useState(false);
  const hasUnread = unreadCount > 0;
  const badgeLabel = unreadCount > 99 ? '99+' : String(unreadCount);

  return (
    <>
      <button
        type='button'
        onClick={() => setShowPanel(true)}
        className={`relative p-2 text-gray-400 transition-colors hover:text-gray-500 dark:text-gray-300 dark:hover:text-white ${className}`}
        title={hasUnread ? `الإشعارات (${unreadCount} غير مقروء)` : 'الإشعارات'}
        aria-label={
          hasUnread ? `الإشعارات، ${unreadCount} غير مقروء` : 'الإشعارات'
        }
        aria-haspopup='dialog'
        aria-expanded={showPanel}
      >
        {hasUnread ? (
          <BellSolidIcon
            className='h-6 w-6 text-primary-600'
            aria-hidden='true'
          />
        ) : (
          <BellIcon className='h-6 w-6' aria-hidden='true' />
        )}

        {hasUnread && (
          <span className='absolute -left-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1'>
            <span className='text-xs font-medium text-white'>
              {badgeLabel}
            </span>
          </span>
        )}
      </button>

      <NotificationsPanel
        isOpen={showPanel}
        onClose={() => setShowPanel(false)}
        onOpenCenter={onOpenCenter}
      />
    </>
  );
};

export default NotificationsBell;
